module.exports = __webpack_public_path__ + "img/1557614102309838849.57b8d41e.png";